<div class="p-5 flex flex-col min-h-screen lg:max-w-xl xl:max-w-2xl 2xl:max-w-2xl mx-auto" 
[ngClass]="contentAlign">
    <ng-content></ng-content>
</div>